var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17L9.35355 16.6464L9.20711 16.5H9V17ZM15 17V16.5H14.7929L14.6464 16.6464L15 17ZM4.5 7C4.5 6.17157 5.17157 5.5 6 5.5V4.5C4.61929 4.5 3.5 5.61929 3.5 7H4.5ZM4.5 15V7H3.5V15H4.5ZM6 16.5C5.17157 16.5 4.5 15.8284 4.5 15H3.5C3.5 16.3807 4.61929 17.5 6 17.5V16.5ZM9 16.5H6V17.5H9V16.5ZM8.64645 17.3536L10.9393 19.6464L11.6464 18.9393L9.35355 16.6464L8.64645 17.3536ZM10.9393 19.6464C11.5251 20.2322 12.4749 20.2322 13.0607 19.6464L12.3536 18.9393C12.1583 19.1346 11.8417 19.1346 11.6464 18.9393L10.9393 19.6464ZM13.0607 19.6464L15.3536 17.3536L14.6464 16.6464L12.3536 18.9393L13.0607 19.6464ZM18 16.5H15V17.5H18V16.5ZM19.5 15C19.5 15.8284 18.8284 16.5 18 16.5V17.5C19.3807 17.5 20.5 16.3807 20.5 15H19.5ZM19.5 7V15H20.5V7H19.5ZM18 5.5C18.8284 5.5 19.5 6.17157 19.5 7H20.5C20.5 5.61929 19.3807 4.5 18 4.5V5.5ZM6 5.5H18V4.5H6V5.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11H12.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11H8.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11H16.5",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChat);
export default __webpack_public_path__ + "static/media/ic_chat.e1ef0d6e4a61ee3931b379f798227dd0.svg";
export { ForwardRef as ReactComponent };